// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout_layout__JRS7U","main":"layout_main__C_6_k"};